var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuckleType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M31.7 46.998a19.8 19.8 0 0 1-4.476-3.443 20 20 0 0 1-3.447-4.476q-.264-.496-.477-1.016l-7.863 8.084a1.49 1.49 0 0 0-.4 1.387l1.326 5.86a1.49 1.49 0 0 0 1.127 1.127l5.86 1.322a1.49 1.49 0 0 0 1.383-.4l7.813-8.036c-.29-.135-.559-.255-.846-.409",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0E2240",
  d: "M33.384 27.386a1.2 1.2 0 0 0-1.724-.009l-.017.018-6.517 6.518c-.552.552-1 1.529-.376 3.284.137.278.265.623.455.972a18.3 18.3 0 0 0 3.142 4.056 18.3 18.3 0 0 0 4.061 3.147q.467.269.972.451.467.18.96.27a2.6 2.6 0 0 0 2.3-.552l6.606-6.57a1.23 1.23 0 0 0-.035-1.75zm1.361 15.493a11.9 11.9 0 0 1-4.087-2.92 11.9 11.9 0 0 1-2.93-4.08l4.785-4.785 2.325 2.325-2.634 2.638a1.619 1.619 0 0 0 2.29 2.289l2.633-2.634 2.4 2.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M54.568 23.936a19.8 19.8 0 0 1-4.477-3.443 20 20 0 0 1-3.447-4.477q-.263-.496-.477-1.016L34.822 26.576c-.04.041 9.035 9.556 9.4 9.194L55.42 24.342c-.295-.134-.564-.252-.852-.406",
  opacity: 0.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h70v70H0z"
})))));
export { SvgBuckleType as ReactComponent };
export default "/_next/static/images/buckle-type.svg";